import { render, staticRenderFns } from "./AltView.vue?vue&type=template&id=4301d715&scoped=true&"
import script from "./AltView.vue?vue&type=script&lang=js&"
export * from "./AltView.vue?vue&type=script&lang=js&"
import style0 from "./AltView.vue?vue&type=style&index=0&id=4301d715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301d715",
  null
  
)

export default component.exports